module.exports = __webpack_public_path__ + "static/media/search.f1ab916c.svg";